import { useState } from 'react';
import PeriodDayToggle from './PeriodDayToggle';
import InseminationDayToggle from './InseminationDayToggle';

/**
 * IPDayActions - Wrapper component for IP user's main calendar actions
 * Contains period day toggle and insemination day toggle with future date validation
 *
 * Props:
 * - ipData: Calendar data for the selected day (ipData object)
 * - date: Selected date string (YYYY-MM-DD)
 */
function IPDayActions({ ipData, date }) {
  const [message, setMessage] = useState(null);

  // Check if date is in the future
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  const selectedDate = new Date(date);
  selectedDate.setHours(0, 0, 0, 0);
  const isFutureDate = selectedDate > today;
  const isInseminationDay = ipData?.inseminationDay ?? false;

  return (
    <>
      {/* Period day toggle + insemination button - two main actions for IP users */}
      <div className="grid grid-cols-2 gap-2 mb-4">
        {/* Toggle period day on/off for this date */}
        <PeriodDayToggle ipData={ipData} date={date} isFutureDate={isFutureDate} setMessage={setMessage} />
        {/* Toggle insemination day on/off for this date */}
        <InseminationDayToggle ipData={ipData} date={date} isFutureDate={isFutureDate} setMessage={setMessage} />
      </div>

      {/* Alert message */}
      {message && message.type === 'alert' && (
        <div className="mb-4 rounded-lg bg-yellow-100 px-4 py-2 text-center text-xs font-semibold text-yellow-800">
          {message.text}
        </div>
      )}

      {/* Good luck message when insemination day is set */}
      {isInseminationDay && (
        <div className="mb-2 text-center text-sm font-semibold text-[#bfdbfe]">
          ✨🌈 Good luck! 🍀😁
        </div>
      )}
    </>
  );
}

export default IPDayActions;
